import { type ReactNode } from 'react'
import { ScrollReveal } from './ScrollReveal'

interface PageHeroProps {
  title: string
  subtitle?: string
  as?: 'h1' | 'h2'
  className?: string
  children?: ReactNode
}

export function PageHero({
  title,
  subtitle,
  as: Component = 'h1',
  className = '',
  children,
}: PageHeroProps) {
  return (
    <section
      className={`relative bg-heading min-h-[40vh] md:min-h-[50vh] flex items-center overflow-hidden ${className}`}
      aria-label={title}
    >
      {/* Cerchi decorativi */}
      <div
        className="absolute top-0 right-0 w-96 h-96 rounded-full border border-white/5 translate-x-1/3 -translate-y-1/3"
        aria-hidden="true"
      />
      <div
        className="absolute bottom-0 left-0 w-64 h-64 rounded-full border border-brand/20 -translate-x-1/3 translate-y-1/3"
        aria-hidden="true"
      />

      {/* Pattern diagonale sottile */}
      <div className="absolute inset-0 opacity-10" aria-hidden="true">
        <div className="absolute -top-1/2 -left-1/4 w-[150%] h-[200%] rotate-12 bg-[repeating-linear-gradient(45deg,transparent,transparent_20px,rgba(255,255,255,0.03)_20px,rgba(255,255,255,0.03)_40px)]" />
      </div>

      <div className="relative mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8 py-16 md:py-24 text-center">
        <ScrollReveal>
          <Component className="font-display text-h1 text-white mb-4">
            {title}
          </Component>
          {subtitle && (
            <p className="text-white/80 text-lg md:text-xl max-w-2xl leading-relaxed mx-auto">
              {subtitle}
            </p>
          )}

          {/* Linea tecnica signature */}
          <div className="mt-8 md:mt-10 flex items-center justify-center gap-0">
            <div className="h-px w-16 md:w-24 bg-brand" />
            <div className="w-1.5 h-1.5 rounded-full bg-brand" />
            <div className="h-px w-16 md:w-24 bg-brand" />
          </div>

          {children}
        </ScrollReveal>
      </div>
    </section>
  )
}
